/** * * Asynchronously loads the component for
Number Change
* */ import { lazyLoad } from "utils/loadable";
export const NumberChange = lazyLoad(
  () => import("./index"),
  (module) => module.NumberChange
);
